<template lang="html">
  <div class="mt-2 text-center">
    <i class="far text-6xl text-push-orange fa-folder-open"></i>
    <p class="m-4 text-xl">Oh no! Your dashboard is empty</p>
    <router-link
      class="bg-push-orange py-2 text-white uppercase px-8 inline-block"
      :to="{ name: 'add-poll' }"
      >Create a Poll</router-link
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="css"></style>
